import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const drawerWidth = 296;

export const useStyles = makeStyles()(({ mixins, palette, spacing }: Theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
  },
  appBar: {
    backgroundColor: palette.primary.dark,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    color: palette.secondary.lightest,
    backgroundColor: palette.primary.dark,
    borderRight: 0,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: spacing(0, 1),
  },
  // necessary for content to be below app bar
  toolbar: mixins.toolbar as Record<string, never>,
  menu: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    paddingBottom: spacing(3),
  },
  content: {
    overflow: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flexGrow: 1,
  },
  button: {
    width: '100%',
    '& .MuiButton-startIcon': {
      display: 'none',
    },
  },
  chip: {
    fontWeight: 'bold',
    marginLeft: spacing(2),
  },
  logoFound: {
    height: 42,
  },
}));
